import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Zohran Kush · Cannabis Policy & Culture</p>
        <h1>Welcome to Zohran Kush</h1>
        <p className="lede">
          Your go-to source for the latest updates and insights on cannabis policy and culture in our community. 
          Explore our comprehensive coverage of local laws, educational resources, and news on cannabis-related topics.
        </p>
        <div className="cta-row">
          <a href="/law-updates" target="_self">
            Latest Law Updates
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Educational Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Cannabis Law Updates</h2>
          <p>
            Stay informed with timely updates on cannabis legislation and policy changes affecting our area.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Get clear and concise information about the legal status of cannabis in our community, including regulations and rights.
          </p>
        </article>
        <article>
          <h2>Educational Content</h2>
          <p>
            Access a wealth of resources designed to educate the public about cannabis culture, usage, and its impact on society.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;